var exports = {
  "o": "xaee3c4fa--2fcd50--tooltip-container",
  "Y": "xaee3c4fa--2fcd50--tooltip",
};

module.exports = exports;
